import React, { useState } from 'react';
import { Box } from '@mui/material';
import { CustomButton, CustomRadioGroup } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';
const questionConfig = getQuestionConfig(ProfilerQuestionID.FMCG_STORE_TYPE);

const StoreType = ({
  questionId = ProfilerQuestionID.FMCG_STORE_TYPE,
  title = questionConfig?.question,
  value,
  defaultValue = '',
  onChange,
  onSubmit,
  submitLabel = 'Submit',
  options = questionConfig?.options || [],
}) => {
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;

  const handleSelect = (nextValue) => {
    if (!isControlled) {
      setInternalValue(nextValue);
    }
    onChange?.(nextValue);
  };
  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selectedValue }
      ]
    });
  };

  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2}}>
          <CardHeader title={title} />

          <CustomRadioGroup
            options={options}
            value={selectedValue}
            onChange={(_, val) => handleSelect(val)}
            name="store-type"
            size='small'
          />
        </Box>
        <CustomButton
          size='small'
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selectedValue}
          sx={{ width: '100%'}}
        />
      </Box>
    </Box>
  );
};

export default StoreType;
